import { render, staticRenderFns } from "./BuscadorInventarioIndex.vue?vue&type=template&id=5f2c5a8c&"
import script from "./BuscadorInventarioIndex.vue?vue&type=script&lang=js&"
export * from "./BuscadorInventarioIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports